<template>
  <div>
    <div class="youlegoupage">
      <div class="youlegoutopbox">
        <div class="youlegoutop">
          <!-- <div class="accountbox111">
            <img class="accounticon" src="../../../static/youlegoujifen.png" />
            <div class="accounttopnum">1002</div>
          </div> -->
          <div class="gousearchbox">
            <img class="gousearchicon" src="../../../static/youlegousearch.png" />
            <input class="gousearchinput" v-model="keyword" placeholder="请输入您要搜索的商品" />
            <div class="gousearchtext" @click="searchkey">搜索</div>
          </div>
        </div>
        <div class="tabbox">
          <van-tabs @change="onChange" :active="tabIndex">
            <van-tab v-for="(item,index) in tablist" :title="item.title"></van-tab>
          </van-tabs>
        </div>
      </div>
      <div class="youlegoutopnone"></div>
      <scroller :on-infinite="infinite">
        <div v-if="productList.length>0">
          <div class="youlegouproduct2box" v-for="(item,index) in productList" @click="toproDetail(item.id)">
            <img class="youlegouproduct2img" :src="item.thumb"></img>
            <div class="youlegouproduct2detail">
              <div class="youlegouproduct2namebox">
                <div class="youlegouproduct2remai">{{item.tags}}</div>
                <div class="youlegouproduct2name">{{item.name}}</div>
              </div>
              <div class="youlegouproduct2desc">{{item.desc}}</div>
              <div class="youlegouproduct2pricebox">
                <div class="youlegouproduct2price"><span style="font-size: 12px;">￥</span>{{item.price}}</div>
                <div class="youlegouproduct2buy">马上购买</div>
              </div>
            </div>
          </div>
        </div>
        <div class="youlegounone_iconbox" v-else>
          <img src="/static/youlegounone.png" class="youlegounone_icon" />
        </div>
        <div class="youlegounone1"></div>
      </scroller>


      <!-- <div class="youlegoumenulist">
        <div class="youlegoumenubox">
          <img class="youlegoumenuicon" src="../../../static/shipinjiushui.png" />
          <div class="youlegoumenutext">食品酒水</div>
        </div>
      </div>
      <div class="youlegouhotbox">
        <div class="baokuantuijianbox">
          <div class="hotleft">
            <div class="texttitle">爆款推荐</div>
            <div class="hotline"></div>
            <div class="hotgengxin">每天10点更新</div>
          </div>
          <div class="hotright">
            <div class="hotmoretext">更多好物</div>
            <img class="hotmoreicon" src="../../../static/gengduolan.png" />
          </div>
        </div>
        <div class="hotproductlist">
          <div class="hotproductbox">
            <img class="hotproductimg" src="../../../static/shipinjiushui.png" />
            <div class="hoticonbox">
              <div class="hotbaokuan">爆款</div>
              <div class="hotproductname">食品酒水食品酒水食品酒水</div>
            </div>
            <div class="hotprice">￥15.00</div>
          </div>
        </div>
      </div>
      <div class="tablist">
        <div class="tabbox2">猜你喜欢</div>
        <div class="tabbox1">汽车精品</div>
      </div>
      <div class="youlegouproductlist">
        <div class="youlegouproductbox">
          <img class="youlegouproductimg" src="/static/xiangbaojiafang.png" />
          <div class="youlegouproductnamebox">
            <div class="youlegouproducthot">热卖 </div>
            <div class="youlegouproductname">箱包家纺箱包家纺箱包家纺箱包家纺箱包家纺箱包家纺箱包家纺箱包家纺箱包家纺</div>
          </div>
          <div class="youlegouproductprice">￥399</div>
        </div>
      </div> -->
    </div>
    <!-- <div class="youlegounone"></div> -->
    <taber></taber>
  </div>
</template>

<script>
  import taber from '@/components/taber/taber'
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    components: {
      taber
    },
    data() {
      return {
        tablist: [{
          name: "全部商品",
          id: 1
        }, {
          name: "汽车精品",
          id: 2
        }, {
          name: "食品酒水",
          id: 3
        }, {
          name: "生活用品",
          id: 4
        }, {
          name: "家用电器",
          id: 5
        }],
        tabIndex: 0,
        userInfo: {}, //用户信息
        productList: [], //商品列表
        cate_id: 0,
        keyword: "",
        page: 1,
        page_size: 20,
        datalengthX: false
      }
    },
    created() {
      this.request('getUserInfo')
    },
    mounted() {

    },
    methods: {
      searchkey() {
        let that = this
        this.page = 1
        this.productList = []
        this.request("getshoplist", {
          cate_id: that.cate_id,
          keyword: that.keyword,
          page: that.page,
          page_size: that.page_size
        })
      },
      onChange(e) {
        let that = this
        this.cate_id = this.tablist[e].id
        this.page = 1
        this.productList = []
        this.request("getshoplist", {
          cate_id: that.cate_id,
          page: that.page,
          page_size: that.page_size
        })
      },
      infinite(done) {
        let that = this
        setTimeout(function() {
          if (that.lengthX) {
            let pages = (that.page) + 1
            that.page = pages
            this.request("getshoplist", {
              cate_id: that.cate_id,
              page: that.page,
              page_size: that.page_size
            })
          }
          done(456)
        }, 1000)
      },
      //跳转商品详情页
      toproDetail(index) {
        let that = this
        let id = index
        that.$router.push({
          path: "/youlegoudetail",
          query: {
            id: id
          }
        })
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          // 获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                that.userInfo = res.data
                this.request("getindexcate")

                // var userId = [167,168]
                // for (var i = 0; i < userId.length; i++) {
                //   if (userId[i] == that.userInfo.id) {
                //     that.availableUser = true
                //   }
                // }
              }
            }, true)
            break
            // 分类
          case 'getindexcate':
            httper.get('/shop/index-cate', requestData, res => {
              if (res.code == 0) {
                that.tablist = res.data
                this.request("getshoplist", {
                  cate_id: that.tablist[0].id
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //
          case 'getshoplist':
            httper.get('/shop/get-list', requestData, res => {
              if (res.code == 0) {
                let lengthX = res.data.length - that.page_size === 0 //判断列是否20条
                that.datalengthX = lengthX
                // that.list = [...this.list, ...res.data] //数据拼接,
                if (res.data.length > 0) {
                  let list = that.productList;
                  for (let i = 0; i < res.data.length; i++) {
                    list.push(res.data[i]);
                  }
                  that.productList = list
                }
                //that.productList = res.data
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
    },
  }
</script>

<style>
  .youlegoutopbox {
    width: 90%;
    position: fixed;
    top: 0;
    padding-top: 20px;
    background-color: #FFFFFF;
    z-index: 2;
  }

  .tabbox {
    width: 100%;
  }

  .van-ellipsis {
    overflow: visible !important;
  }

  .van-tab {
    min-width: auto !important;
    font-size: var(--tab-font-size, 16px) !important;
  }

 /* .van-tabs__nav {
    background-color: transparent;
  } */

  .van-tab__text {
    font-size: 16px;
  }

  /* .van-tabs__line {
    background-color: #FF7609 !important;
    width: 19px !important;
  } */

  .van-tab--active {
    font-weight: bold;
  }

  ._v-container {
    height: calc(100% - 140px) !important;
    top: 140px !important;
    width: calc(100% - 40px) !important;
    right: 0 !important;
    left: 20px !important;
  }

  .youlegoupage {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }

  .youlegoutop {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .accountbox111 {
    width: 107px;
    height: 31px;
    background: #D2EAF8;
    border-radius: 15px;
    display: flex;
    align-items: center;
  }

  .accounticon {
    width: 46px;
    height: 27px;
    border-radius: 13px;
  }

  .accounttopnum {
    width: calc(100% - 50px);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #029DFF;
  }

  .gousearchbox {
    width: 100%;
    height: 35px;
    border: 1px solid #FF7609;
    border-radius: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .gousearchicon {
    width: 16px;
    height: 16px;
    margin-right: 10px;
    margin-left: 14px;
  }

  .gousearchinput {
    width: calc(100% - 120px);
    height: 100%;
    border: none;
    outline: none;
    background-color: transparent;
    font-size: 14px;
  }

  ::-webkit-input-placeholder {
    text-align: start !important;
    color: #BBBBBB;
    font-size: 12px;
  }

  .gousearchtext {
    width: 69px;
    height: 100%;
    border-radius: 17px;
    font-size: 15px;
    color: #FFFFFF;
    background-color: #FF7609;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .youlegoubanner {
    width: 100%;
    height: 192px;
    margin-bottom: 20px;
  }

  .youlegoutopnone {
    width: 100%;
    height: 130px;
  }

  .youlegoumenulist {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .youlegoumenubox {
    width: 62px;
    margin: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .youlegoumenuicon {
    width: 50px;
    height: 50px;
    margin-bottom: 8px;
  }

  .youlegoumenutext {
    font-size: 12px;
  }

  .youlegouhotbox {
    width: 100%;
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
    border: 1px solid #029DFF;
    background: linear-gradient(-45deg, #F2FAFE 0%, #D2EAF8 100%);
    border-radius: 15px;
    margin-top: 10px;
  }

  .baokuantuijianbox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .hotleft {
    display: flex;
    align-items: center;
  }

  .texttitle {
    font-size: 23px;
    color: #029DFF;
    font-weight: 600;
  }

  .hotline {
    width: 2px;
    height: 15px;
    background: #2995F0;
    margin: 0 16px;
  }

  .hotgengxin {
    font-size: 14px;
    color: #029DFF;
  }

  .hotright {
    display: flex;
    align-items: center;
  }

  .hotmoretext {
    font-size: 14px;
    color: #029DFF;
    margin-right: 15px;
  }

  .hotmoreicon {
    width: 6px;
    height: 11px;
  }

  .hotproductlist {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .hotproductbox {
    width: 102px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 6px;
    box-sizing: border-box;
    margin: 6px;
  }

  .hotproductimg {
    width: 77px;
    height: 77px;
    margin-bottom: 6px;
  }

  .hoticonbox {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .hotbaokuan {
    width: 23px;
    height: 14px;
    background: linear-gradient(90deg, #029DFF 0%, #087BFF 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    color: #FFFFFF;
    margin-right: 5px;
  }

  .hotproductname {
    font-size: 8px;
    width: calc(100% - 30px);
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }

  .hotprice {
    font-size: 14px;
    color: #029DFF;
  }

  .youlegounone {
    width: 100%;
    height: 100px;
    background-color: #FFFFFF;
  }

  .youlegounone1 {
    width: 100%;
    height: 60px;
    background-color: #FFFFFF;
  }

  .tablist {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }

  .tabbox1 {
    width: 77px;
    height: 31px;
    background: #E5E5E5;
    border-radius: 15px;
    margin: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #666666;
  }

  .tabbox2 {
    width: 77px;
    height: 31px;
    background: #029DFF;
    border-radius: 15px;
    margin: 0 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #FFFFFF;
  }

  .youlegouproductlist {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .youlegouproductbox {
    width: 170px;
    margin: 8px;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #FFFFFF;

  }

  .youlegouproductimg {
    width: 100%;
    height: 170px;
    margin-bottom: 16px;
  }

  .youlegouproductnamebox {
    width: 100%;
    display: flex;
    align-items: center;
  }

  .youlegouproducthot {
    width: 23px;
    height: 11px;
    background: linear-gradient(90deg, #029DFF 0%, #087BFF 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    color: #FFFFFF;
    margin-right: 5px;
    shape-outside: inset(0 30px 0 0);
  }

  .youlegouproductname {

    font-size: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }

  .youlegouproductprice {
    font-size: 19px;
    color: #029DFF;
  }

  .youlegouproduct2box {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #FF7F02;
    margin-bottom: 20px;
    border-radius: 8px;
    display: flex;
    align-items: center;
  }

  .youlegouproduct2box1 {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #DCDCDC;
    margin-bottom: 20px;
    border-radius: 8px;
    display: flex;
    align-items: center;
  }

  .youlegouproduct2img {
    width: 115px;
    height: 111px;
    margin-right: 10px;
    border-radius: 8px;
  }

  .youlegouproduct2detail {
    width: calc(100% - 140px);


  }

  .youlegouproduct2namebox {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .youlegouproduct2remai {
    width: 26px;
    height: 15px;
    background: linear-gradient(90deg, #FF7D02 0%, #FF5A20 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: #FFFFFF;
    margin-right: 5px;
    shape-outside: inset(0 30px 0 0);
  }

  .youlegouproduct2name {
    width: calc(100% - 30px);
    font-size: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }

  .youlegouproduct2desc {
    font-size: 14px;
    margin-bottom: 40px;
    color: #BBBBBB;
  }

  .youlegouproduct2pricebox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .youlegouproduct2price {
    font-size: 19px;
    color: #FF7608;
  }

  .youlegouproduct2buy {
    width: 68px;
    height: 25px;
    background: linear-gradient(90deg, #FF7D02 0%, #FF5A20 100%);
    border-radius: 4px;
    font-size: 14px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .youlegounone_iconbox {
    width: calc(100% - 40px);
    margin: 100px 20px 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .youlegounone_icon {
    width: 150px;
    height: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/youlegou/youlegou.vue